export default "__VITE_ASSET__3973470a__"